// @flow
import styled, { css } from 'styled-components';
import { ecoGreen, g500 } from '../../colors';
import InfoBubbleTheme from '../../info-bubble/theme';
var Container = styled.div.withConfig({
  displayName: "theme__Container",
  componentId: "br963u-0"
})(["display:inline-block;height:4rem;display:flex;align-items:center;"]);
var Label = styled.label.withConfig({
  displayName: "theme__Label",
  componentId: "br963u-1"
})(["box-sizing:border-box;cursor:pointer;position:relative;padding-left:3rem;overflow-wrap:break-word;"]);
var Button = styled.span.withConfig({
  displayName: "theme__Button",
  componentId: "br963u-2"
})(["box-sizing:border-box;height:2rem;width:2rem;border:2px solid ", ";border-radius:50%;display:inline-block;position:absolute;top:1px;left:0;&:before{box-sizing:border-box;content:\"\";display:block;height:4rem;width:4rem;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%) scale(", ");opacity:", ";border-radius:50%;background-color:", ";transition:all 0.2s ease-out;}", " &::after{box-sizing:border-box;content:\"\";display:block;height:1rem;width:1rem;border-radius:50%;background-color:", ";position:absolute;top:50%;left:50%;transform:translate(-50%,-50%) scale(", ");opacity:", ";transition:all 0.1s;}"], function (pr) {
  return pr.clicked || pr.checked ? ecoGreen() : g500();
}, function (pr) {
  return pr.clicked ? 1 : 0;
}, function (pr) {
  return pr.clicked ? '0.12' : '0';
}, ecoGreen(), function (pr) {
  return !pr.clicked && css(["&:hover{&:before{transform:translate(-50%,-50%) scale(1);opacity:0.04;}}"]);
}, ecoGreen(), function (pr) {
  return pr.checked ? 1 : 0;
}, function (pr) {
  return pr.checked ? 1 : 0;
});
var thm = {
  Container: Container,
  Label: Label,
  Button: Button,
  InfoBubbleTheme: InfoBubbleTheme
};
export default thm;